import { window } from './facade/browser';
export function isBs3() {
    return window.__theme !== 'bs4';
}
//# sourceMappingURL=ng2-bootstrap-config.js.map


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/venyou-stripe/~/ngx-bootstrap/utils/ng2-bootstrap-config.js
// module id = ../../../../ngx-bootstrap/utils/ng2-bootstrap-config.js
// module chunks = 3